import { forwardRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Card from "../../common/components/Card";
import { Col, Row } from "../../common/components/Grid";
import FormEditor from "../../common/components/GridEditor";
import ReactForm from "../../common/components/ReactForm";
import TextInput from "../../common/components/TextInput";
import useCredentials from "../../common/hooks/credentialsHook";
import useNetwork from "../../common/hooks/networkHook";
import { canCreateTaskList, canRemoveTaskList, canUpdateTaskList, insertTaskList, removeTaskList, updateTaskList, useTaskLists } from "../../reducers/taskListSlice";
import PropTypes from 'prop-types';
import { TaskListPermissions } from "../TaskListPermissions";
import SimpleSettings from "./SimpleSettings";

const defaultSort = ['name'];
const defaultTaskList = { def: [], perms: [], read_crews: [], write_crews: [], read_users: [], write_users: [] };

const TaskListLabel = ({ value: taskList }) => <Row>
    <Col className="text-left">
        {taskList.name}
    </Col>
</Row>

const TaskListDetails = forwardRef(({ value: currentTaskList, disabled, onChange }, ref) => {
    const { t } = useTranslation();
    return <>
        <ReactForm ref={ref}>
            <Row>
                <Col>
                    <TextInput value={currentTaskList.name} placeholder={t('name')} disabled={disabled} required={true} onChange={name => onChange({ name })}></TextInput>
                </Col>
            </Row>
        </ReactForm>
        <TaskListPermissions taskList={currentTaskList} disabled={disabled} onChange={onChange}></TaskListPermissions>
        <Card title={t('taskListEntryDefintion')}>
            <FormEditor def={currentTaskList.def} onChange={def => onChange({ def })} hideAccess></FormEditor>
        </Card>
    </>
})

const TaskLists = ({ uuid, label, onClose }) => {
    const { t } = useTranslation();
    const network = useNetwork();
    const credentials = useCredentials();
    const taskLists = useTaskLists();
    const sortFields = useMemo(() => {
        let fields = { name: t('name') }
        return fields;
    }, [t]);

    return <SimpleSettings data={taskLists} uuid={uuid} label={label} pkey="id" defaultSort={defaultSort} sortFields={sortFields}
        templateItem={defaultTaskList} canAdd={taskList => canCreateTaskList(credentials, taskList)}
        canUpdate={taskList => canUpdateTaskList(credentials, taskList)}
        canRemove={taskList => canRemoveTaskList(credentials, taskList)}
        onAdd={taskList => insertTaskList(network, taskList)}
        onRemove={taskList => removeTaskList(network, taskList)}
        onChange={(taskList, delta) => updateTaskList(network, { id: taskList.id, ...delta })}
        onClose={onClose} ItemLabel={TaskListLabel} ItemDetails={TaskListDetails}></SimpleSettings>
}
TaskLists.propTypes = {
    /**
     * ID to identify the settings status entry
     */
    uuid: PropTypes.string.isRequired,
    /**
     * Label for the screen
     */
    label: PropTypes.string.isRequired,
    /**
     * Function to call when the screen is closed
     */
    onClose: PropTypes.func
}

export default TaskLists;